import { render, staticRenderFns } from "./FundoIcms.vue?vue&type=template&id=74f1d1b8&scoped=true&"
import script from "./FundoIcms.vue?vue&type=script&lang=js&"
export * from "./FundoIcms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f1d1b8",
  null
  
)

export default component.exports